import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import * as actions from '../../store/actions/index';
import ListItem from '../../components/UI/List/ListItem/ListItem';
import useScreenStyles from '../useScreenStyles';

const TrainStations = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useScreenStyles();
    const selectedTrainLine = useSelector((state) => state.cta.selectedTrainLine);
    const trainStations = useSelector((state) => state.cta.trainStations);
    const isLoading = useSelector((state) => state.cta.loading);

    const onLoadCtaTrainStations = useCallback(
        () => dispatch(actions.loadCtaTrainStations(selectedTrainLine)),
        [dispatch, selectedTrainLine]
    );

    const onSelectedTrainStation = (stop) => {
        dispatch(actions.setSelectedTrainStation(stop));
        history.push('/trainStationPredictions');
    }

    const onBackButtonHandler = () => {
        history.goBack();
    };

    useEffect(() => {
        onLoadCtaTrainStations();
    }, [onLoadCtaTrainStations]);

    if (isLoading) {
        return <LinearProgress />;
    }

    return (
        <React.Fragment>
            <Box display="flex">
                <IconButton aria-label="back" onClick={onBackButtonHandler}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography className={classes.headerTitle}>Which Train Station?</Typography>
            </Box>
            <Divider light />
            {trainStations.map((station) => (
                <ListItem key={station.stopId} item={station} onClick={onSelectedTrainStation}/>
            ))}
        </React.Fragment>
    );

}

export default TrainStations;